// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"29":"419aa061e2ff6fff","145":"a14b87e6204aacc3","239":"650cb11dfbb26506","436":"09873e92f858bc22","596":"f9749847c78de044","695":"7963bdc300f45479","758":"20612a3b33072781","830":"3fc7771cbbbf9178","879":"3a5028d9b558fab7","880":"d235d7e5a8baaa50","980":"08b0c2309c58f8ee"}[chunkId] + ".js";
};